import Component from "@ember/component";
export default Component.extend({
  classNames: ["categories-and-top"],
});
